import * as React from "react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Input } from "@progress/kendo-react-inputs";
import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import { HoverDangerDiv, Icon } from "./PersonalFilterStyles";
import { CustomFilter, PersonalFilterButtonProps } from "./PersonalFilterInterfaces";
import { WhiteButton } from "./WhiteButton";

export default function PersonalFilterButton({
  onClick,
  onDeleteClick,
  editMode,
  customFilter,
  onChange,
}: PersonalFilterButtonProps) {
  const handleInputChange = (e: InputChangeEvent) => {
    const updatedCustomFilter: CustomFilter = {
      name: `${e.target.value}`,
      uuid: customFilter.uuid,
      dataState: customFilter.dataState,
    };
    onChange(updatedCustomFilter);
  };

  return editMode ? (
    <HoverDangerDiv>
      <Input value={customFilter.name} onChange={handleInputChange} />
      <Icon icon={faTrash} onClick={onDeleteClick} />
    </HoverDangerDiv>
  ) : (
    <WhiteButton onClick={onClick}>{customFilter.name}</WhiteButton>
  );
}
